import { FC, HTMLAttributes } from 'react';

type FlowWalletProps = HTMLAttributes<SVGElement> & {
  size?: number;
};

const FlowWallet: FC<FlowWalletProps> = ({ size = 16, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 400 400"
      fill="none"
      {...props}
    >
      <g clipPath="url(#flowWallet_clippath_a)">
        <circle cx="199" cy="199" r="200" fill="#00EF8B" />
        <path
          d="M285.653 167.531H229.594V223.567H285.653V167.531Z"
          fill="white"
        />
        <path
          d="M173.641 244.555C173.641 248.715 172.407 252.781 170.095 256.24C167.783 259.698 164.497 262.394 160.653 263.986C156.808 265.578 152.577 265.994 148.496 265.183C144.415 264.371 140.666 262.368 137.723 259.426C134.781 256.486 132.777 252.738 131.966 248.658C131.154 244.578 131.57 240.349 133.162 236.506C134.755 232.664 137.452 229.379 140.912 227.067C144.371 224.757 148.44 223.524 152.601 223.524H173.641V167.531H152.601C137.361 167.531 122.464 172.048 109.792 180.512C97.1204 188.976 87.2444 201.005 81.4124 215.079C75.5803 229.153 74.0543 244.641 77.0275 259.582C80.0007 274.523 87.3394 288.247 98.1151 299.019C108.892 309.791 122.622 317.126 137.569 320.099C152.516 323.07 168.008 321.546 182.088 315.716C196.168 309.886 208.202 300.013 216.669 287.347C225.135 274.681 229.655 259.788 229.655 244.555V223.524H173.641V244.555Z"
          fill="white"
        />
        <path
          d="M250.624 139.536H313.665V83.5039H250.624C230.195 83.5249 210.609 91.6467 196.162 106.087C181.716 120.527 173.591 140.106 173.57 160.527V167.551H229.585V160.527C229.595 154.957 231.817 149.618 235.761 145.682C239.706 141.746 245.052 139.536 250.624 139.536Z"
          fill="white"
        />
        <path
          d="M173.57 223.528H229.589V167.531H173.57V223.528Z"
          fill="#00EF8B"
        />
      </g>
      <defs>
        <clipPath id="flowWallet_clippath_a">
          <rect width="400" height="400" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FlowWallet;
